module.exports = __webpack_public_path__ + "static/media/copy.db6d058d.svg";